import { map, head, sortBy, compose, keyBy, getOr } from 'lodash/fp';
import { Layout } from 'react-grid-layout';
import { Place, Section } from '../../server-types';
import { DEFAULT_TABLE_SIZE } from '../../constants';
import { Identified } from '../../types';

interface TableMapPlace extends Layout {
    name: string;
    isToGo: boolean;
}

type PlacesToLayoutMapper = (places: Array<Place> | undefined) => Array<TableMapPlace>;

export const mapPlacesToLayout: PlacesToLayoutMapper = map(
    ({ coordinateX, coordinateY, id, ...other }) => ({
        ...other,
        i: id,
        x: coordinateX,
        y: coordinateY,
        w: DEFAULT_TABLE_SIZE,
        h: DEFAULT_TABLE_SIZE,
    }));

export const getActiveSectionId = compose(
    getOr<Section, 'id', string>('', 'id'),
    head,
    sortBy<Section>('ordering')
);
export const keyById = <T extends Identified>(items: Array<T> | null | undefined) => keyBy('id', items);

export const mapTabs = compose(sortBy('createdAt'),map(({ id, name }) => ({ id, name })));
